import { useState, useEffect } from 'react';
import { getStudiosOptionsData } from '@gp/services/projectDetail';
import { isArray, isEmpty, sortBy } from 'lodash-es';
import { fetchCommonConditions } from '@gp/services/filter';
import { fetchProjectTechnicalsConditions } from '@gp/services/projectTechnical';

// useTeamGameInfo hooks
const useTeamGameInfo = (props: any) => {
  const { projectId, isNeedCommon = true } = props;
  const [studioOptionList, setStudioOptionList] = useState([]);
  const [condDetailOptions, setCondDetailOptions] = useState({});
  const [engineOptionList, setEngineOptionList] = useState<any>([]);

  const getStudioOptionList = async () => {
    try {
      const res = await getStudiosOptionsData();
      const stuList = res?.data || [];
      if (isArray(stuList) && !isEmpty(stuList)) {
        // a-z排序
        const sortStudioList: any = sortBy(stuList, (o: { name: string }) => o.name)?.map(
          (t: any) => {
            return {
              text: t?.name,
              value: t?.id,
              pteam: t?.pteam,
              studio_location_city: t?.studio_location_city,
              studio_location_country: t?.studio_location_country,
            };
          },
        );
        setStudioOptionList(sortStudioList);
      }
    } catch (err) {
      setStudioOptionList([]);
    }
  };
  const getCommonCond = async () => {
    try {
      const commonCondParams = {
        ip: [],
        genre: [],
        bussiness_model: [],
        platform: [],
      };
      const res = await fetchCommonConditions(commonCondParams);
      setCondDetailOptions(res || {});
    } catch (err) {
      setCondDetailOptions({});
    }
  };
  const getTechOptionList = async (projectId: string) => {
    try {
      const res = await fetchProjectTechnicalsConditions({ id: projectId });
      const engineList = res || {};
      // const engineList = res?.list?.engine || [];
      setEngineOptionList(engineList);
    } catch (err) {
      setEngineOptionList([]);
    }
  };

  useEffect(() => {
    getStudioOptionList();
    if (isNeedCommon) {
      getCommonCond();
    }
  }, [isNeedCommon]);

  useEffect(() => {
    if (projectId) {
      getTechOptionList(projectId);
    }
  }, [projectId]);

  return {
    studioOptionList,
    condDetailOptions,
    engineOptionList,
  };
};

export default useTeamGameInfo;
